<template>
  <div class="w-100 py-5 px-10">
    <ScrollBar height="720px" width="100%">
      <div class="d-flex" style="width: max-content;">
        <PipelinePrevisionStep
            v-for="(prevision, index) in previsions"
            :key="index"
            :year="prevision.year"
            :month="prevision.month_number"
            :opportunities="prevision.opportunities"
            :currencyIso="defaultCurrency?.symbol"
            :currencySymbol="defaultCurrency?.symbol"
            :estimated-amount="prevision.estimated_gain"
            :concluded-amount="prevision.amount_deals_concluded"
            :total-amount="prevision.total_opportunity_amount"
            :count="prevision.opportunities_count"
            style="width: 325px;"
        />
      </div>
    </ScrollBar>
  </div>
</template>

<script setup>

import PipelinePrevisionStep from "@/Modules/CRM/components/PipelinePrevisionStep.vue";
import {computed, defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import ScrollBar from "@/components/ScrollBar.vue"

const store = useStore()
const router = useRouter()

const props = defineProps({
  filter: {
    type: Object,
    default: () => ({
      startDate: '',
      endDate: '',
      status: '',
      contact: '',
      search: ''
    })
  }
})

const isLoading = ref(false)
const previsions = ref(null)

const defaultCurrency = computed(() => store.getters["company/getCompanyCurrency"])

watch(() => props.filter, (value) => {
  if (!isLoading.value) {
    loadPipelinePrevisions(props.filter, true)
  }
}, {deep: true})


async function loadPipelinePrevisions(query) {
   const { data: data } = await store.dispatch('pipelines/loadPipelinesByForecast', query)
  previsions.value = data
}
function loadData() {
  Promise.all([
    loadPipelinePrevisions(props.filter)
  ]).finally(() => isLoading.value = false)
}

onMounted(() => {
  loadData()
})

</script>


<style scoped>

</style>
